/**
 * MSAL instance for reuse across the app
 */
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./msalConfig";

// Create a single MSAL instance to reuse
export const msalInstance = new PublicClientApplication(msalConfig);

// Init MSAL right away
(async () => {
  try {
    // This must be called and awaited before any other MSAL methods
    await msalInstance.initialize();
    
    // Handle any redirects after init is done
    const result = await msalInstance.handleRedirectPromise();
    console.log("MSAL ready!");
    
    // Check if we have accounts and try to login if not
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      console.log("No accounts found, starting login flow");
      try {
        await msalInstance.loginPopup(loginRequest);
        console.log("Login successful!");
      } catch (loginError) {
        console.error("Login failed:", loginError);
      }
    } else {
      console.log("User already logged in:", accounts[0].username);
    }
  } catch (error) {
    console.error("MSAL init failed:", error);
  }
})();